import { render, staticRenderFns } from "./closeForm.vue?vue&type=template&id=037a7c1c"
import script from "./closeForm.vue?vue&type=script&lang=js"
export * from "./closeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports